import {call, put, takeLatest, delay} from 'redux-saga/effects';
import {
  DocumentUploadActionTypes,
  changeDocuments,
  fetchDocuments,
  DocumentUploadDto,
} from '../ducks/documentUploadHistory';
import {Loading, Loaded, AsyncResult} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import documentApi from '../api/documentApi';

export function* getDocumentsSaga(action: ReturnType<typeof fetchDocuments>) {
  const {sort, pageOption, filter} = action.payload;

  if (filter) {
    const {policyNumber, accountNumber, fileName} = filter;
    if (policyNumber || accountNumber || fileName) {
      yield delay(1500);
    }
  }

  yield put(changeDocuments(new Loading(pageOption)));

  const result: AsyncResult<Page<DocumentUploadDto>> = yield call(documentApi.fetchDocuments, filter, sort);

  yield pipe(
    result,
    E.map(value => new Loaded(value)),
    E.fold(
      error => put(changeDocuments(error)),
      value => put(changeDocuments(value))
    )
  );
}

export default function* documentUploadSaga() {
  yield takeLatest(DocumentUploadActionTypes.FETCH_DOCUMENTS, getDocumentsSaga);
}
